/* Premier Strength Co — theme behaviour */
(function () {
  'use strict';

  /* Sticky header state */
  function initHeader() {
    var hdr = document.getElementById('psco-header');
    if (!hdr) return;
    var onScroll = function () { hdr.classList.toggle('scrolled', window.scrollY > 20); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile menu (event delegation so it survives section reloads) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#psco-menu-btn');
    if (btn) {
      var nav = document.getElementById('psco-navlinks');
      if (!nav) return;
      var open = nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var navLink = e.target.closest('#psco-navlinks a');
    if (navLink) {
      var n = document.getElementById('psco-navlinks');
      var b = document.getElementById('psco-menu-btn');
      if (n) n.classList.remove('open');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
  });

  /* FAQ accordion (delegated) */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.faq > button');
    if (!trigger) return;
    var item = trigger.parentElement;
    var ans = item.querySelector('.ans');
    var isOpen = item.classList.contains('open');
    var group = item.closest('.faq-wrap') || document;
    group.querySelectorAll('.faq.open').forEach(function (o) {
      o.classList.remove('open');
      var a = o.querySelector('.ans');
      if (a) a.style.maxHeight = null;
      var bb = o.querySelector('button');
      if (bb) bb.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('open');
      if (ans) ans.style.maxHeight = ans.scrollHeight + 'px';
      trigger.setAttribute('aria-expanded', 'true');
    }
  });

  /* Scroll reveal */
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14 })
    : null;

  function initReveals(root) {
    (root || document).querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      if (io) { io.observe(el); } else { el.classList.add('in'); }
    });
  }

  function initAll() { initHeader(); initReveals(document); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  /* Re-init when a section is added/edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    initHeader();
    initReveals(e.target);
  });
})();
